import { render, staticRenderFns } from "./sidebarmenu.vue?vue&type=template&id=eb20c01e&scoped=true&"
import script from "./sidebarmenu.vue?vue&type=script&lang=js&"
export * from "./sidebarmenu.vue?vue&type=script&lang=js&"
import style0 from "./sidebarmenu.vue?vue&type=style&index=0&id=eb20c01e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb20c01e",
  null
  
)

export default component.exports